import { render } from "./Music.vue?vue&type=template&id=35329d8b&bindings={\"currentMusic\":\"setup\"}"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"
script.render = render

export default script